import 'babel-polyfill'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vuetify from '@/plugins/vuetify'
import vueFlagIcon from 'vue-flag-icon'
import VueAnalytics from 'vue-analytics'

// App core
import store from '@/core/store'
import App from '@/core/App.vue'
import router from '@/core/router'

import SVGInjectorVue from 'svginjector-vue'

import '../node_modules/nprogress/nprogress.css'

Vue.use(vueFlagIcon)
Vue.use(VueI18n)
// SVG Icons
Vue.use(SVGInjectorVue)

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA,
  // checkDuplicatedScript: true,
  router,
  debug: {
    enabled: true,
    sendHitTask: false
  },
  autoTracking: {
    screenview: true
  }
})

Vue.config.productionTip = false

import messages from '@/languages/messages'
import dateTimeFormats from '@/languages/dateTimeFormats'
import numberFormats from '@/languages/numberFormats'

// let locale = navigator.language
const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: "fr",
  messages,
  dateTimeFormats,
  numberFormats
})

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
